import { z } from 'zod';

/** `GET /api/bots/:botId/conversations` query — cursor is an opaque base64url string
 * (see `packages/db/src/repos/conversations-view.ts` `encodeCursor`/`decodeCursor`); an
 * unparseable cursor is treated as "no cursor" by the repo rather than erroring, since it
 * can only come from a stale/tampered client, not a validation-worthy client mistake. */
export const conversationsQuerySchema = z.object({
  cursor: z.string().min(1).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(30),
});

export type ConversationsQuery = z.infer<typeof conversationsQuerySchema>;
